
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/online-opportunities",
      function () {
        return require("private-next-pages/stories/online-opportunities.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/online-opportunities"])
      });
    }
  